import {
  fireEventIfLoginStateChanged,
  hel_net_is_logged_in,
  loginStateChangeEmitter
} from './logics/auth';
import {hel_skyway_set_user_name} from './logics/skyway';

import type {ProfileResponseSchema} from '../../HeliportJS/dist/models/profile';
import type {Return} from '../../HeliportJS/dist/models/return';

let userName: string | null = null;

Object.assign(globalThis, {
  /**
   * @remarks
   * HeliodorのCanvas層 (HeliScript層) から呼び出される関数。
   * それ以外からの呼び出しは禁止。
   */
  hel_net_is_logged_in,

  /**
   * @remarks
   * HeliodorのC++層から、ロード完了直後の入室ダイアログ表示のために呼び出される関数。
   * それ以外からの呼び出しは禁止。
   * @see https://github.com/VRHIKKY/WorldViewer/blob/b397b865e8cb71a6fc5e7eefbe961ffb3ade10f0/Heliodor/Source/App/CEmscriptenEvent.cpp#L457-L478
   */
  hel_account_isloggedin: hel_net_is_logged_in,

  /**
   * @remarks
   * HeliodorのC++層から呼び出される関数。
   * それ以外からの呼び出しは禁止。
   * @see https://github.com/VRHIKKY/WorldViewer/blob/b397b865e8cb71a6fc5e7eefbe961ffb3ade10f0/Heliodor/Source/App/CEmscriptenEvent.cpp#L527-L536
   * @returns
   */
  hel_account_setusernamefromaccount: (): void => {
    if (userName === null) {
      return;
    }

    hel_skyway_set_user_name(userName);
  }
});

loginStateChangeEmitter.addEventListener(
  'change',
  async function () {
    if (!hel_net_is_logged_in()) {
      return;
    }

    const result =
      (await globalThis.heliport.v3.api.profiles.fetchMyProfile()) as Return<ProfileResponseSchema>;
    if (result.status !== 'ok') {
      console.error(result);
      throw new Error(
        'heliport.v3.api.profiles.fetchMyProfile() failed: ' + JSON.stringify(result)
      );
    }

    userName = result.data.profile.name;
  },
  {once: true}
);

fireEventIfLoginStateChanged();

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    return;
  }

  fireEventIfLoginStateChanged();
});

window.addEventListener('focus', () => {
  fireEventIfLoginStateChanged();
});
